import React, { useEffect, useState } from 'react';
import { Spinner } from './Spinner';

export interface FullPageSpinnerProps {
	text: string;
	hidden?: boolean;
}

export const FullPageSpinner: React.FC<FullPageSpinnerProps> = ({ text, hidden = false }: FullPageSpinnerProps) => {
	const [show, setShow] = useState('');

	useEffect(() => {
		document.body.setAttribute('aria-busy', (!hidden).toString());
		document.body.classList[hidden ? 'remove' : 'add']('modal-open');
		setShow(hidden ? '' : 'show');

		return () => {
			document.body.setAttribute('aria-busy', 'false');
			document.body.classList.remove('modal-open');
		};
	}, [hidden]);

	return hidden ? null : (
		<>
			<div className={`fade modal ${show} d-flex align-items-center`} tabIndex={-1} role="dialog">
				<div className="modal-dialog">
					<Spinner text={text} />
				</div>
			</div>
			<div className={`modal-backdrop fade ${show}`} />
		</>
	);
};
